<template>
  <base-section id="features" class="secondary">
    <base-section-heading dark color="grey lighten-2" title="Features" class="white--text"></base-section-heading>

    <v-responsive class="mx-auto" max-width="1350">
      <v-container fluid>
        <v-row>
          <v-col v-for="card in cards" :key="card.title" cols="12" sm="6" md="4">
            <base-info-card align="center" dark v-bind="card" />
          </v-col>
        </v-row>
        <v-btn color="primary" to="features">{{ $t('SHOW ME THE FEATURES IN DETAIL') }}</v-btn>
      </v-container>
    </v-responsive>
  </base-section>
</template>

<script>
export default {
  name: "SectionFeatures",

  data: () => ({
    cards: [
      {
        icon: "mdi-keyboard-outline",
        title: "Accessibility",
        texts: ["Search, filter and sort your media directly_", "Everything is at most two clicks away_", "No breaking screen changes_"]
      },
      {
        icon: "mdi-database",
        title: "Ultimate Meta Data",
        texts:
          ["Media Hoarder doesn't stop at providing genres and release years_", "We go as deep as full credits, content advisories, production companies, filming locations, plot keywords and much more!"],
      },
      {
        icon: "mdi-table-search",
        title: "Discover",
        texts:
          ["With Media Hoarder you can keep large collections of media under control_", "Use combined filters to discover what fits your audience or current mood_", "Ask an AI for recommendations (powered by ChatGPT)_"],
      },
      {
        icon: "mdi-clipboard-list-outline",
        title: "Organize",
        texts:
          ["Create your own lists to organize your media for your children, special occasions or the next movie night_", "Your lists are also a filter criteria and thus can be combined with other filters_"]
      },
      {
        icon: "mdi-account-supervisor-circle-outline",
        title: "Socialize",
        texts: ["Copy the movie title, IMDB link and your 5-star rating with one click to tell others what you think about it_", "Open the corresponding IMDB or Letterboxd page by the click of a button_", "Join a discussion by visiting the corresponding moviechat_org entry of a selected movie_"]
      },
      {
        icon: "mdi-github",
        title: "Free and Open Source",
        texts: ["If you are a developer, feel free to add your features by joining the team!", "Media Hoarder is developed with a modern tech stack consisting of Electron, Node_js, Vue_js and Vuetify_"]
      },
    ],
  }),
};
</script>
